// Minimal CSV export helper.
// `rows` is an array of plain objects; `columns` is an array of
// { header, accessor } where accessor is a fn(row) => value.
// Values are coerced to string, wrapped in quotes, and inner quotes doubled.

function escapeCell(v) {
  if (v == null) return "";
  const s = typeof v === "string" ? v : String(v);
  // Always quote — simplest safe path for Excel/Numbers/Sheets.
  return `"${s.replace(/"/g, '""')}"`;
}

export function rowsToCsv(rows, columns) {
  const header = columns.map((c) => escapeCell(c.header)).join(",");
  const body = rows
    .map((r) => columns.map((c) => escapeCell(c.accessor(r))).join(","))
    .join("\n");
  return `${header}\n${body}`;
}

export function downloadCsv(filename, csv) {
  // Prepend BOM so Excel reliably detects UTF-8.
  const blob = new Blob(["\ufeff", csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function slugForFilename(s) {
  if (!s) return "export";
  return String(s)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60) || "export";
}

export function todayStamp() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
